import { GridFilterReducer } from '../../../common/grid/filter/grid-filter.reducer';
import { GridReducer } from '../../../common/grid/grid.reducer';
import {pnpDocumentEventActionsGrid} from './pnp-doc/event-actions/grid/pnp-doc-event-actions-grid.component';

// Shared document structure
const defaultPnpDocument = () => ({
    id: null,
    title: null,
    version: '1.0',
    docNum: null,
    documentType: null,
    documentCategory: null,
    dueDate: null,
    documentRiskLevel: null,
    documentApplicationType: null,
    docStatus: null,
    path: null,
    location: null,
    locationName: null,
    accountId: null,
    riskDuration: null,
    prefixName: null,
    reviewApproverTypes: null,
    selectedReviewer: null,
    selectedReviewers: [],
    selectedApprover: null,
    selectedApprovers: [],
    locations: [],
    documentTypes: [],
    documentCategories: [],
    pnpLinkedToAccreditation: [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' }
    ],
    documentRiskLevels: [],
    documentApplicationTypes: [],
    autocompleteReviewers: [],
    autocompleteApprovers: [],
    comment: null,
    documentAccreditationSchemes: [],
    selectdocumentAccreditationSchemes: null,
    documentAccreditationSection: [],
    selectCascadeStandard: {
        level1Standards: [],
        level2Standards: [],
        level3Standards: [],
        level1StandardId: null,
        level2StandardId: null,
        level3StandardId: null,
    },
    documentCategoryName: null,
    documentTypeName: null,
});

export default {
    pnpDocument: defaultPnpDocument(),
    pnpDocumentHistory: defaultPnpDocument(),
    pnpDocumentGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer(),
            identifier: 'pnpDocument'
        }
    },
    pnpDocumentApprovalGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer(),
            identifier: 'pnpDocument'
        }
    },
    pnpDocumentHistoryGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer(),
            identifier: 'pnpDocumentHistoryGrid',
            id:null,
        }
    },
    pnpDocumentAccreditationGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer(),
            identifier: 'pnpDocument',
            id:null
        }
    },
    pnpDocSectionsGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer(),
            identifier: 'pnpDocument'
        }
    },
    pnpDocumentEventActionsGrid: {
        ...GridReducer(),
        items: [],
        itemsCount: 0,
        filter: {
            ...GridFilterReducer(),
            identifier: 'pnpDocument',
            id:null
        }
    },
};
